import React, { Component } from 'react';
import { Dashboard } from '../../components/Dashboard';
import PropTypes from 'prop-types';

export default class KeepOnScreenPositioner extends Component {

	static propTypes = {
		startPosition: PropTypes.shape({
			x: PropTypes.number,
			y: PropTypes.number
		}).isRequired,
		minHeight: PropTypes.number
	};


	constructor(props) {
		super(props);
		this.state = {
			calculatedPosition: null
		};
		this.childRef = React.createRef();
		this.recalculatePosition = this.recalculatePosition.bind(this);
		this.timeout = null;
	}

	componentDidUpdate() {
		this.recalculatePosition();
	}

	componentDidMount() {
		this.recalculatePosition();
		// this.timeout = setInterval(() => {
		// 	this.recalculatePosition();
		// }, 1000);
	}

	componentWillUnmount() {
		clearInterval(this.timeout);
	}

	recalculatePosition() {
		const { startPosition, minHeight } = this.props;
		if(this.childRef.current && startPosition) {
			const position = Dashboard.calculateKeepOnScreenPosition(this.childRef.current, {
				x: startPosition.x,
				y: startPosition.y,
				minHeight: minHeight
			});
			this.setState((prevState) => {
				if(prevState.calculatedPosition === null
					|| (Math.abs(prevState.calculatedPosition.y - position.top) > 3
						|| Math.abs(prevState.calculatedPosition.x - position.left) > 3)) {
					return {
						calculatedPosition: { x: position.left, y: position.top, },
					};
				}
			});
		}
	}

	render() {
		const { startPosition, rounded, width, height, className } = this.props;
		const { calculatedPosition } = this.state;
		const position = calculatedPosition || startPosition;
		return (
			<div
				ref={this.childRef}
				style={{
					top: position.y,
					left: position.x,
					width,
					height,
				}}
				className={`keep_on_screen_positioner popout_card ${rounded ? 'rounded' : ''} ${className || ''}`}>
				{this.props.children}
			</div>
		);
	}
}